import VueBaseController from '../vue_base'

// eslint-disable-next-line import/prefer-default-export
export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/teams/index.vue') }

  static values = {
    currentUserEmail: String
  }

  connect() {
    super.connect({
      currentUserEmail: this.currentUserEmailValue
    })
  }
}
